import Group from 'components/utils/Group'
import { fillArray } from 'lib/array/arrayUtils'
import React from 'react'
import LoyaltyNightsProgressPill from './LoyaltyNightsProgressPill'

interface Props {
  numberOfNights: number
  numberOfNightsForTierUpgrade: number
}

function determineInitial(numberOfNightsForTierUpgrade: number): [initialIndividuals: Array<number>, initialsSummary: number] {
  let whole10s = Math.floor(numberOfNightsForTierUpgrade / 10) * 10
  let remainder = numberOfNightsForTierUpgrade % Math.max(whole10s, 10)
  if (remainder === 0) {
    whole10s -= 10
    remainder = 10
  }
  return [
    fillArray(Math.min(remainder, 10)),
    whole10s,
  ]
}

function LoyaltyAccountNightsProgress({ numberOfNights, numberOfNightsForTierUpgrade }: Props) {
  const activesSummary = Math.floor(numberOfNights / 10) * 10
  const activeIndividuals = fillArray(numberOfNights % 10)
  const [initialIndividuals, initialsSummary] = determineInitial(numberOfNightsForTierUpgrade)

  return <Group
    direction="horizontal"
    horizontalAlign="space-between"
    fullWidth
    tabletHorizontalAlign="start"
    tabletGap={8}
  >
    {!!activesSummary && <LoyaltyNightsProgressPill state="active" caption={`x${activesSummary}`} />}
    {activeIndividuals.map(active => <LoyaltyNightsProgressPill key={active} state="active" />)}
    {initialIndividuals.map(initial => <LoyaltyNightsProgressPill key={initial} state="initial" />)}
    {!!initialsSummary && <LoyaltyNightsProgressPill state="initial" caption={`x${initialsSummary}`} />}
  </Group>
}

export default LoyaltyAccountNightsProgress
